import React, {useEffect, useRef, useState} from 'react';
import '../../polyfill/urlsearchparams.es5';
import {ArticleOverviewStaticProvider} from '../ArticleOverviewStatic.jsx';
import Loadingbar from './Loader.jsx';
import {createUrlFromCurrentUrl} from '../ArticleOverviewHelper.js';
import ArticleOverviewContent from './ArticleOverviewContent.jsx';

export default function ArticleOverview({
                                            givenArticleContent,
                                            givenFilterContent,
                                            givenHeaderContent,
                                            givenNavigationContent,
                                            givenLandmarkContent,
                                            givenConfigurationContent,
                                            givenShopContent,
                                            givenSearchResultContent,
                                            givenSeoContent,
                                            givenResponseLimitations,
                                            givenRecommendationContent,
                                            pointOfSaleId,
                                            givenTeaserContent,
                                            givenSanitizedUrl,
                                            givenRankingTrackingValue,
                                        }) {
    const [articleContent] = useState(givenArticleContent);
    const [filterContent] = useState(givenFilterContent);
    const [overviewContent] = useState({
        navigationContent: givenNavigationContent,
        headerContent: givenHeaderContent,
        landmarkContent: givenLandmarkContent,
        shopContent: givenShopContent,
        searchResultContent: givenSearchResultContent,
        seoContent: givenSeoContent,
        responseLimitations: givenResponseLimitations,
        recommendationContent: givenRecommendationContent,
        rankingTrackingValue: givenRankingTrackingValue,
    });

    const shopContent = overviewContent.shopContent;
    const searchContext = !shopContent?.id;
    const initialUrl = createInitialUrl();

    const searchParamsRef = useRef(initialUrl.searchParams);
    const categoryPathRef = useRef(shopContent?.prettyUrl);
    const filterRootShopIdRef = useRef(shopContent?.filterRootShopId);
    const prettyUrlRef = useRef(shopContent?.prettyUrl);
    const rootCategoryPathRef = useRef(shopContent?.rootCategoryPath);
    const shopIdRef = useRef(shopContent?.id);
    const urlPathRef = useRef(initialUrl.pathname);

    useEffect(() => {
        const isScrollRestorationSupported = 'scrollRestoration' in window.history;
        if (isScrollRestorationSupported) {
            // disable automatic scroll restoration to prevent page jumping (due anchor parameter + auto scroll) and improve CLS
            window.history.scrollRestoration = 'manual';
        }
        return () => {
            if (isScrollRestorationSupported) {
                window.history.scrollRestoration = 'auto';
            }
        };
    }, []);

    return (
        <>
            <Loadingbar/>
            <ArticleOverviewStaticProvider
                configurationContent={givenConfigurationContent}
                searchParams={searchParamsRef}
                categoryPath={categoryPathRef}
                filterRootShopId={filterRootShopIdRef}
                prettyUrl={prettyUrlRef}
                rootCategoryPath={rootCategoryPathRef}
                shopId={shopIdRef}
                urlPath={urlPathRef}
            >
                <ArticleOverviewContent
                    givenArticleContent={articleContent}
                    givenShopContent={shopContent}
                    givenRecommendationContent={overviewContent.recommendationContent}
                    givenFilterContent={filterContent}
                    givenLandmarkContent={overviewContent.landmarkContent}
                    givenNavigationContent={overviewContent.navigationContent}
                    givenHeaderContent={overviewContent.headerContent}
                    pointOfSaleId={pointOfSaleId}
                    givenResponseLimitations={overviewContent.responseLimitations}
                    givenSearchResultContent={overviewContent.searchResultContent}
                    givenSeoContent={overviewContent.seoContent}
                    givenTeaserContent={givenTeaserContent}
                    givenSearchContext={searchContext}
                    givenSanitizedUrl={givenSanitizedUrl}
                    givenConfErrorCase={givenConfigurationContent.errorCase}
                    givenRankingTrackingValue={overviewContent.rankingTrackingValue}
                />
            </ArticleOverviewStaticProvider>
        </>
    );

    function createInitialUrl() {
        if (givenSanitizedUrl) {
            const currentUrl = new URL(window.location.href);
            const url = currentUrl.origin + givenSanitizedUrl;
            const calculatedUrl = createUrlFromCurrentUrl(searchContext, url);

            history.replaceState({}, '', currentUrl);
            return calculatedUrl;
        } else {
            return createUrlFromCurrentUrl(searchContext);
        }
    }
}
